/**
 * lasEscalaciones — cuántas escalaciones del agente esperan a una persona ahora mismo.
 *
 * Es el número que va en el sidebar de Chats: el agente pidió ayuda y nadie la tomó. Medido el
 * 12-sep: 5/5 vencidas sin que nadie las viera, porque la cola no estaba en ningún menú.
 * ADR-013: la consulta vive acá; la pantalla sólo pinta.
 */
import { supabase } from '@/lib/supabase';

export async function contarEscalacionesPendientes(tenantId: string): Promise<number> {
  const { count, error } = await supabase
    .from('agent_escalations')
    .select('id', { count: 'exact', head: true })
    .eq('tenant_id', tenantId)
    .in('estado', ['pendiente', 'vencida']);
  if (error) throw error;
  return count ?? 0;
}
